import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Un enlace con ancla (#plazos-de-entrega) quiere llevarte a ese punto, no
    // al principio de la página.
    if (!hash) {
      window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
      return;
    }

    // Las páginas se cargan en diferido (React.lazy), así que al llegar desde
    // otra ruta el destino todavía no está en el DOM. Se reintenta durante un
    // segundo largo y, si no aparece, se deja la página donde está en lugar de
    // dar un salto al inicio que el visitante no ha pedido.
    const id = hash.slice(1);
    let frame = 0;
    let tries = 0;

    const look = () => {
      const target = document.getElementById(id);
      if (target) {
        target.scrollIntoView({ block: 'start' });
        return;
      }
      if (tries++ < 90) frame = requestAnimationFrame(look);
    };

    look();
    return () => cancelAnimationFrame(frame);
  }, [pathname, hash]);

  return null;
}
